import { h, Fragment } from "preact";
import { Text } from "preact-i18n";
import CloseIcon from "icons/CloseIcon";
import ArrowIcon from "icons/ArrowIcon";
import EditIcon from "icons/EditIcon";
import styles from "./style.module.scss";
import type MvAdressResult from "models/MvAddressResult";
interface Props {
    currentAddress: MvAdressResult | null;
    isDisabled: boolean;
    isFetching: boolean;
    isOpen: boolean;
    onRemove(): void;
    onToggle(): void;
    onEdit(): void;
}
const AreaHeader = ({
    currentAddress,
    isDisabled,
    isFetching,
    isOpen,
    onRemove,
    onToggle,
    onEdit,
}: Props) => (
    <Fragment>
        {!isDisabled && (
            <button
                type="button"
                disabled={isFetching}
                className={styles.mvAreaRemoveButton}
                title="close"
                onClick={onRemove}
            >
                <CloseIcon />
            </button>
        )}
        <div className={styles.mvTopBar}>
            <button type="button" disabled={isFetching} onClick={onToggle}>
                <ArrowIcon
                    className={`${styles.mvArrowIcon} ${isOpen && styles.open}`}
                    fill={"currentColor"}
                />
                {currentAddress ? (
                    <span>
                        {currentAddress.straatnaam} {currentAddress.huisnr}
                        {currentAddress.huisnr_bag_letter
                            ? `${currentAddress.huisnr_bag_letter}${
                                  currentAddress.huisnr_bag_toevoeging || ""
                              }`
                            : ""}
                        , {currentAddress.postcode} {currentAddress.plaatsnaam}
                    </span>
                ) : (
                    <span>
                        <Text id="general.buttons.newAddress">New address</Text>
                    </span>
                )}
            </button>

            {currentAddress && !isDisabled && (
                <button
                    type="button"
                    disabled={isFetching}
                    onClick={onEdit}
                    className={styles.mvEditButton}
                >
                    <EditIcon fill={"currentColor"} />
                </button>
            )}
        </div>
    </Fragment>
);
export default AreaHeader;
